import { Typography } from '@mui/material'
import { C1CountDisplay } from 'components/core/count/C1CountDisplay'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { C1Link } from 'components/core/links/C1Link'
import { AppValue } from 'lib/actions/apps'
import { routes } from 'lib/routes'
import { AppRef } from 'pbts/c1/api/app/v1/app'
import { FC } from 'react'
import { getAppUserCountApi } from 'redux_toolkit/app-user-count'

interface AppUserCountProps {
    app: AppValue
}

const MAX_DISPLAY_COUNT = 10_000

export const AppUserCount: FC<AppUserCountProps> = ({ app }) => {
    const { data, isLoading } = getAppUserCountApi.useMultiGet(
        AppRef.create({ id: app.id }),
    )

    if (isLoading || !data) {
        return <C1EmptyIndicator />
    }

    return <Typography>
        <C1Link href={routes.applications.accounts(app.id)}>
            <C1CountDisplay value={data.count} maxCount={MAX_DISPLAY_COUNT} />
        </C1Link>
    </Typography>
}
